
export const updateTopNav = (props) => {
	const nav = document.querySelector('header');
	nav.removeAttribute('hidden');
	const subjectDIV = document.querySelector('#topNavSubject');
	if (subjectDIV !== null) {
		subjectDIV.innerHTML = '';
		if (props.image !== undefined) {
			var img = document.createElement('img');
			img.src = props.image;
			img.className = "w-35 m-auto d-block add-height"
			subjectDIV.appendChild(img);
		} else if(props.input){
			var input = document.createElement('input');
			input.className =props.input.className;
			input.id=props.input.id
			input.type=props.input.type
			input.placeholder= props.input.placeholder
			input.autofocus=props.input.autofocus
			input.autocomplete="off"
			// if (props.input.defaultValue) {
			// 	input.defaultValue=props.input.defaultValue
			// }
			
			subjectDIV.appendChild(input);
		}
		else {
			var span = document.createElement('span');
			span.innerText = props.title;
			span.className = "text-center w-80 m-auto overflow-hidden d-block nav-title";
			subjectDIV.appendChild(span);
		}
	}
	const tools = document.querySelector('#topNavButtons');
	if (tools === null) {
		return
	}
	tools.innerHTML = '';
	props.buttons.map((item, index) => {
		var div = document.createElement('div');
		div.id = props.id;
		div.className = "mr-3 mt-3 overflow-hidden";

		if (typeof (item.icon) === 'string') {
			var i = document.createElement('i');
			i.className = `icon ${item.icon}`;
			div.appendChild(i);
		}
		else {
		
			div.appendChild(initElement(subjectDIV, item.icon));
		}
		div.onclick = () => { item.click() };

		tools.appendChild(div);
	})
}

const initElement = (parent, item) => {
	var n = {};
	
	if (item.type === 'svg' || item.type === 'path' || item.type === 'g' || item.type === 'circle' ) {
		n = document.createElementNS('http://www.w3.org/2000/svg', item.type);
		if (item.props.width) {
			n.setAttribute('width', item.props.width);
		}
		if (item.props.height) {
			n.setAttribute('height', item.props.height);
		}
		if (item.props.d) {
			n.setAttribute('d', item.props.d);
		}
		if (item.props.fill) {
			n.setAttribute('fill', item.props.fill);
		}
		if (item.props.viewBox) {
			n.setAttribute('viewBox', item.props.viewBox);
		}
	}
	else {
		n = document.createElement(item.type);
		if (item.props.width) {
			n.setAttribute('width', item.props.width);
		}
		if (item.props.height) {
			n.setAttribute('height', item.props.height);
		}
		if (item.props.src) {
			n.setAttribute('src', item.props.src);
		}
	}

	parent.appendChild(n);
	if (Array.isArray(item.props.children)) {
		item.props.children.map((i) => {
			initElement(n, i);
		})
	}
	else if (item.props.children) {
		initElement(n, item.props.children);
	}
	return n;
}

export const hiddenNav = () => {
	const nav = document.querySelector('nav[role="navigation"]');
	nav.setAttribute('hidden', true);
}

export const hiddenToolbal = (isHide = true) => {
	const nav = document.querySelector('header');
	if (!isHide) {
		nav.removeAttribute('hidden');
		return
	}
	nav.setAttribute('hidden', true);
}
